/** Dedupe case-insensitively, preserve first-seen spelling. */
function dedupeFocusAreaLabels(parts: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const p of parts) {
    const k = p.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(p);
  }
  return out;
}

function normalizeFocusAreaToken(raw: string): string {
  return String(raw).replace(/\+/g, " ").replace(/\s+/g, " ").trim();
}

/** Split segments like "Forehead and Forehead" from malformed CRM rollups. */
function expandAndSeparatedSegments(segment: string): string[] {
  return normalizeFocusAreaToken(segment)
    .split(/\s+and\s+/i)
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * Parse CRM "processed areas of interest" / region lists into deduped labels.
 * Handles comma-separated values, " and " joiners, and duplicate tokens.
 */
export function parseProcessedFocusAreas(
  raw: string | readonly string[] | null | undefined,
): string[] {
  if (raw == null) return [];
  const segments: string[] = [];

  const ingest = (value: string) => {
    normalizeFocusAreaToken(value)
      .split(/[,;·]|(?:\s+-\s+)|(?:\s+&\s+)/)
      .forEach((part) => {
        expandAndSeparatedSegments(part).forEach((s) => segments.push(s));
      });
  };

  if (Array.isArray(raw)) {
    raw.forEach((item) => ingest(String(item)));
  } else {
    ingest(String(raw));
  }

  return dedupeFocusAreaLabels(segments);
}

/** Title-case a single focus area label for display (Skin, Jawline, Full Face). */
export function formatFocusAreaForDisplay(label: string): string {
  const t = normalizeFocusAreaToken(label);
  if (!t) return t;
  return t
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
